import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  informationWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1, 0.5),
  },
  informationWrapperOneColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1, 0.5),
  },
  valueWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
  },
}));

const InformationSummary = ({ data, oneColumn = false }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  if (!data || !data.length) return null;
  return (
    <div className={oneColumn ? styles.informationWrapperOneColumn : styles.informationWrapper}>
      {data.map(({ label, value }, index) => {
        const isReactElement = React.isValidElement(value);
        return (
          <Typography
            key={label || index}
            component='div'
            style={isReactElement ? { display: 'flex', alignItems: 'center', flexWrap: 'nowrap' } : undefined}
          >
            <span>{`${t(...label)}: `}</span>
            {isReactElement ? <div className={styles.valueWrapper}>{value}</div> : <span>{value}</span>}
          </Typography>
        );
      })}
    </div>
  );
};

InformationSummary.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.arrayOf(PropTypes.string),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element, PropTypes.node]),
    }),
  ).isRequired,
};

export default InformationSummary;
